import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";

import SignUpContainer from "app/NativeComponents/components/SignUpContainer";
import LoginContainer from "app/NativeComponents/components/LoginContainer";

import AffiliateLoginContainer from "app/NativeComponents/components/AffiliateLoginContainer";
import AffiliateSignUpContainer from "app/NativeComponents/components/AffiliateSignUpContainer";

import RedirectToLogin from "app/NativeComponents/components/RedirectToLogin";
/* app routes */
import GetStarted from "app/DealMachineCore/components/GetStarted";
import ForgotPassword from "app/DealMachineCore/components/ForgotPassword";
import ResetPassword from "app/NativeComponents/components/ResetPassword";
import RedirectError from "app/NativeComponents/components/RedirectError";

import DealFinderPage from "app/NativeComponents/components/DealFinderPage";

import App from "./App";

class RouteBody extends Component {
  componentDidMount() {
    this.props.initApp(true);
  }

  componentDidUpdate(prevProps) {
    if (this.props.location != prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return (
      <div className="app-wrapper">
        <Switch>
          {/* app routes */}
          <Route exact path="/" component={RedirectToLogin} />
          <Route path="/sign-up" component={SignUpContainer} />
          <Route exact path="/login" component={LoginContainer} />

          <Route
            exact
            path="/affiliate-sign-up"
            component={AffiliateSignUpContainer}
          />
          <Route
            exact
            path="/affiliate-login"
            component={AffiliateLoginContainer}
          />

          <Route exact path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/reset-password" component={ResetPassword} />

          {/* dealfinder page */}
          <Route exact path="/team/:team_link" component={DealFinderPage} />

          {/* app routes */}
          <Route path="/a" component={App} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(connect(null, {})(RouteBody));
